import { Config } from '~admin/config';
import { EventProfileCreateRequest } from '~client/model/admin/event-profile-create-request';
import { EventType } from '~client/model/event-type';

/**
 * Transforms EventBaseFormData to Partial<EventProfileCreateRequest>
 */
export const getAdditionalDetailsRequest = (): Pick<
  EventProfileCreateRequest,
  | 'eventType'
  | 'liveConferenceGreeterMediaId'
  | 'majorCategoryIds'
  | 'minorCategoryIds'
  | 'numInTour'
  | 'paymentVerificationThreshold'
  | 'scheduleMediaId'
  | 'taxRate'
> => {
  return {
    eventType: Config.eventType as EventType,
    liveConferenceGreeterMediaId: Config.liveConferenceGreeterMediaId,
    majorCategoryIds: Config.majorCategoryIds,
    minorCategoryIds: Config.minorCategoryIds,
    numInTour: Config.numInTour,
    paymentVerificationThreshold: Config.paymentVerificationThreshold,
    scheduleMediaId: Config.scheduleMediaId,
    taxRate: Config.taxRate,
  };
};



// WEBPACK FOOTER //
// ./view/components/create-event/helper/event-profile-request/event-additional-details-request.helper.ts